export default __webpack_public_path__ + "static/media/Businessinthetime.a4d5767e.png";